import App from 'app/app.js';

function OrderStatusService($http, $q, MessageStore) {
  this.getOrderStatusDetail = function (email, orderNumber) {
    return $http.get('orderStatusDetail/' + email + '/' + orderNumber).then(
      function (response) {
        MessageStore.clear();
        if (!!response.data && !!response.data.success === true && !!response.data.data) {
          return response.data.data;
        } else {
          MessageStore.createSystem(response.data.error.code);
          return;
        }
      }.bind(this),
      function (error) {
        if (!!error.data && !!error.data.error && !!error.data.error.code) {
          MessageStore.createSystem(error.data.error.code);
        } else {
          MessageStore.createSystem('COMMON_TEXT_ERROR');
        }
        return;
      }
    );
  };
}

App.service('OrderStatusService', ['$http', '$q', 'MessageStore', OrderStatusService]);
